import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import SearchFilters from './components/SearchFilters';
import PropertyMap from './components/PropertyMap';
import PropertyCard from './components/PropertyCard';
import SearchHeader from './components/SearchHeader';
import ComparisonPanel from './components/ComparisonPanel';
import SavedSearches from './components/SavedSearches';

const PropertySearchDiscovery = () => {
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    location: 'bangalore',
    minPrice: '',
    maxPrice: '',
    propertyTypes: [],
    amenities: [],
    proximity: [],
    radius: '5',
    furnishing: []
  });
  const [sortBy, setSortBy] = useState('relevance');
  const [viewMode, setViewMode] = useState('grid');
  const [savedProperties, setSavedProperties] = useState([]);
  const [compareProperties, setCompareProperties] = useState([]);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showSavedSearches, setShowSavedSearches] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Mock property data
  const mockProperties = [
    {
      id: 1,
      title: "Luxury 2 BHK Apartment in Koramangala",
      location: "Koramangala 5th Block, Bangalore",
      price: 28000,
      originalPrice: 32000,
      area: 1200,
      bedrooms: 2,
      bathrooms: 2,
      furnishing: "Fully Furnished",
      status: "available",
      isNew: true,
      ownerVerified: true,
      images: [
        "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1560449752-8d4b8b6b5b8e?w=800&h=600&fit=crop"
      ],
      amenities: ["Parking", "Gym", "Swimming Pool", "Security", "Power Backup"],
      owner: {
        name: "Rajesh Kumar",
        type: "Owner",
        avatar: "https://randomuser.me/api/portraits/men/32.jpg"
      },
      postedDate: "2 days ago",
      lastUpdated: "1 hour ago",
      views: 245,
      inquiries: 12,
      coordinates: { lat: 12.9352, lng: 77.6245 }
    },
    {
      id: 2,
      title: "Modern Studio Near Whitefield Metro",
      location: "Whitefield, Bangalore",
      price: 18000,
      area: 450,
      bedrooms: 1,
      bathrooms: 1,
      furnishing: "Semi Furnished",
      status: "few_left",
      isNew: false,
      ownerVerified: true,
      images: [
        "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop"
      ],
      amenities: ["Metro", "Parking", "Security", "Elevator"],
      owner: {
        name: "Priya Sharma",
        type: "Agent",
        avatar: "https://randomuser.me/api/portraits/women/44.jpg"
      },
      postedDate: "1 week ago",
      lastUpdated: "3 hours ago",
      views: 189,
      inquiries: 8,
      coordinates: { lat: 12.9698, lng: 77.7500 }
    },
    {
      id: 3,
      title: "Spacious 3 BHK Villa with Garden",
      location: "Electronic City Phase 1, Bangalore",
      price: 45000,
      area: 1800,
      bedrooms: 3,
      bathrooms: 3,
      furnishing: "Unfurnished",
      status: "available",
      isNew: true,
      ownerVerified: false,
      images: [
        "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop"
      ],
      amenities: ["Garden", "Parking", "Security", "Power Backup", "Clubhouse"],
      owner: {
        name: "Amit Patel",
        type: "Owner",
        avatar: "https://randomuser.me/api/portraits/men/56.jpg"
      },
      postedDate: "3 days ago",
      lastUpdated: "2 hours ago",
      views: 156,
      inquiries: 15,
      coordinates: { lat: 12.8456, lng: 77.6603 }
    },
    {
      id: 4,
      title: "Cozy 1 BHK Near HSR Layout",
      location: "HSR Layout Sector 2, Bangalore",
      price: 22000,
      area: 650,
      bedrooms: 1,
      bathrooms: 1,
      furnishing: "Fully Furnished",
      status: "available",
      isNew: false,
      ownerVerified: true,
      images: [
        "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop"
      ],
      amenities: ["Parking", "Gym", "Security", "Elevator"],
      owner: {
        name: "Sneha Reddy",
        type: "Owner",
        avatar: "https://randomuser.me/api/portraits/women/28.jpg"
      },
      postedDate: "5 days ago",
      lastUpdated: "4 hours ago",
      views: 203,
      inquiries: 9,
      coordinates: { lat: 12.9116, lng: 77.6473 }
    },
    {
      id: 5,
      title: "Premium 2 BHK in Indiranagar",
      location: "Indiranagar 1st Stage, Bangalore",
      price: 35000,
      area: 1100,
      bedrooms: 2,
      bathrooms: 2,
      furnishing: "Semi Furnished",
      status: "available",
      isNew: false,
      ownerVerified: true,
      images: [
        "https://images.unsplash.com/photo-1560449752-8d4b8b6b5b8e?w=800&h=600&fit=crop",
        "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&h=600&fit=crop"
      ],
      amenities: ["Parking", "Gym", "Swimming Pool", "Security", "Power Backup", "Clubhouse"],
      owner: {
        name: "Vikram Singh",
        type: "Agent",
        avatar: "https://randomuser.me/api/portraits/men/41.jpg"
      },
      postedDate: "1 week ago",
      lastUpdated: "6 hours ago",
      views: 312,
      inquiries: 18,
      coordinates: { lat: 12.9719, lng: 77.6412 }
    },
    {
      id: 6,
      title: "Budget-Friendly Studio in Marathahalli",
      location: "Marathahalli, Bangalore",
      price: 15000,
      area: 400,
      bedrooms: 1,
      bathrooms: 1,
      furnishing: "Unfurnished",
      status: "available",
      isNew: true,
      ownerVerified: false,
      images: [
        "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop"
      ],
      amenities: ["Parking", "Security"],
      owner: {
        name: "Ravi Kumar",
        type: "Owner",
        avatar: "https://randomuser.me/api/portraits/men/67.jpg"
      },
      postedDate: "4 days ago",
      lastUpdated: "1 day ago",
      views: 98,
      inquiries: 5,
      coordinates: { lat: 12.9591, lng: 77.6974 }
    }
  ];

  const [filteredProperties, setFilteredProperties] = useState(mockProperties);

  useEffect(() => {
    // Filter properties based on current filters
    let filtered = mockProperties;

    if (searchQuery) {
      filtered = filtered.filter(property =>
        property.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        property.location.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    if (filters.minPrice) {
      filtered = filtered.filter(property => property.price >= parseInt(filters.minPrice));
    }

    if (filters.maxPrice) {
      filtered = filtered.filter(property => property.price <= parseInt(filters.maxPrice));
    }

    if (filters.propertyTypes.length > 0) {
      filtered = filtered.filter(property => {
        const propertyType = `${property.bedrooms}bhk`;
        return filters.propertyTypes.includes(propertyType);
      });
    }

    if (filters.amenities.length > 0) {
      filtered = filtered.filter(property =>
        filters.amenities.some(amenity =>
          property.amenities.some(propAmenity =>
            propAmenity.toLowerCase().includes(amenity.toLowerCase())
          )
        )
      );
    }

    // Sort properties
    switch (sortBy) {
      case 'price_low':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'price_high':
        filtered.sort((a, b) => b.price - a.price);
        break;
      case 'newest':
        filtered.sort((a, b) => new Date(b.postedDate) - new Date(a.postedDate));
        break;
      case 'area_large':
        filtered.sort((a, b) => b.area - a.area);
        break;
      case 'area_small':
        filtered.sort((a, b) => a.area - b.area);
        break;
      default:
        // Keep original order for relevance
        break;
    }

    setFilteredProperties(filtered);
  }, [searchQuery, filters, sortBy]);

  const handleSaveProperty = (propertyId) => {
    setSavedProperties(prev =>
      prev.includes(propertyId)
        ? prev.filter(id => id !== propertyId)
        : [...prev, propertyId]
    );
  };

  const handleCompareProperty = (propertyId) => {
    setCompareProperties(prev => {
      if (prev.includes(propertyId)) {
        return prev.filter(id => id !== propertyId);
      } else if (prev.length < 3) {
        return [...prev, propertyId];
      }
      return prev;
    });
  };

  const handleRemoveFromCompare = (propertyId) => {
    setCompareProperties(prev => prev.filter(id => id !== propertyId));
  };

  const handleClearComparison = () => {
    setCompareProperties([]);
  };

  const handleClearFilters = () => {
    setFilters({
      location: '',
      minPrice: '',
      maxPrice: '',
      propertyTypes: [],
      amenities: [],
      proximity: [],
      radius: '5',
      furnishing: []
    });
    setSearchQuery('');
  };

  const handleCreateAlert = (alertName) => {
    // Implementation for creating search alert
    console.log('Creating alert:', alertName);
  };

  const handleDeleteSearch = (searchId) => {
    // Implementation for deleting saved search
    console.log('Deleting search:', searchId);
  };

  const handleRunSearch = (searchId) => {
    // Implementation for running saved search
    console.log('Running search:', searchId);
  };

  const comparePropertiesData = compareProperties.map(id =>
    mockProperties.find(property => property.id === id)
  ).filter(Boolean);

  return (
    <div className="min-h-screen bg-canvas">
      <Header />
      
      <div className="pt-16">
        <div className="max-w-7xl mx-auto px-4 py-6">
          {/* Search Header */}
          <SearchHeader
            searchQuery={searchQuery}
            onSearchChange={setSearchQuery}
            sortBy={sortBy}
            onSortChange={setSortBy}
            viewMode={viewMode}
            onViewModeChange={setViewMode}
          />

          {/* Main Content */}
          <div className="flex gap-6">
            {/* Sidebar */}
            <div className="w-80 space-y-6">
              {/* Search Filters */}
              <SearchFilters
                filters={filters}
                onFiltersChange={setFilters}
                onClearFilters={handleClearFilters}
              />

              {/* Saved Searches Toggle */}
              <Button
                variant="outline"
                fullWidth
                onClick={() => setShowSavedSearches(!showSavedSearches)}
                iconName={showSavedSearches ? "ChevronUp" : "ChevronDown"}
                iconPosition="right"
              >
                Saved Searches
              </Button>

              {/* Saved Searches */}
              {showSavedSearches && (
                <SavedSearches
                  onCreateAlert={handleCreateAlert}
                  onDeleteSearch={handleDeleteSearch}
                  onRunSearch={handleRunSearch}
                />
              )}
            </div>

            {/* Main Content Area */}
            <div className="flex-1">
              {/* Results Header */}
              <div className="flex items-center justify-between mb-6">
                <div>
                  <h2 className="text-2xl font-bold text-text-primary">
                    {filteredProperties.length} Properties Found
                  </h2>
                  <p className="text-text-secondary mt-1">
                    {searchQuery ? `Results for "${searchQuery}"` : 'All properties in your area'}
                  </p>
                </div>

                {/* Quick Actions */}
                <div className="flex items-center space-x-2">
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Bell"
                    iconPosition="left"
                  >
                    Create Alert
                  </Button>
                  <Button
                    variant="ghost"
                    size="sm"
                    iconName="Download"
                    iconPosition="left"
                  >
                    Export
                  </Button>
                </div>
              </div>

              {/* Content Based on View Mode */}
              {viewMode === 'map' ? (
                <div className="h-[600px]">
                  <PropertyMap
                    properties={filteredProperties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={setSelectedProperty}
                  />
                </div>
              ) : (
                <div className={`${
                  viewMode === 'grid' ?'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' :'space-y-4'
                }`}>
                  {isLoading ? (
                    // Loading skeleton
                    Array.from({ length: 6 }).map((_, index) => (
                      <div key={index} className="bg-surface border border-border rounded-lg p-4 animate-pulse">
                        <div className="h-48 bg-muted rounded-lg mb-4"></div>
                        <div className="space-y-2">
                          <div className="h-4 bg-muted rounded w-3/4"></div>
                          <div className="h-4 bg-muted rounded w-1/2"></div>
                          <div className="h-6 bg-muted rounded w-1/4"></div>
                        </div>
                      </div>
                    ))
                  ) : filteredProperties.length === 0 ? (
                    // No results
                    <div className="col-span-full text-center py-12">
                      <Icon name="Search" size={64} className="text-text-secondary mx-auto mb-4" />
                      <h3 className="text-xl font-semibold text-text-primary mb-2">
                        No properties found
                      </h3>
                      <p className="text-text-secondary mb-6">
                        Try adjusting your filters or search criteria
                      </p>
                      <Button
                        variant="default"
                        onClick={handleClearFilters}
                        iconName="RotateCcw"
                        iconPosition="left"
                      >
                        Clear All Filters
                      </Button>
                    </div>
                  ) : (
                    // Property Cards
                    filteredProperties.map((property) => (
                      <PropertyCard
                        key={property.id}
                        property={property}
                        onSave={handleSaveProperty}
                        onCompare={handleCompareProperty}
                        isComparing={compareProperties.includes(property.id)}
                        isSaved={savedProperties.includes(property.id)}
                      />
                    ))
                  )}
                </div>
              )}

              {/* Load More Button */}
              {filteredProperties.length > 0 && !isLoading && (
                <div className="text-center mt-8">
                  <Button
                    variant="outline"
                    size="lg"
                    iconName="ChevronDown"
                    iconPosition="left"
                  >
                    Load More Properties
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Comparison Panel */}
      <ComparisonPanel
        compareProperties={comparePropertiesData}
        onRemoveFromCompare={handleRemoveFromCompare}
        onClearAll={handleClearComparison}
        isVisible={compareProperties.length > 0}
      />
    </div>
  );
};

export default PropertySearchDiscovery;